//Hard coded file 
// Image CDN URL for Restaurant card


export const IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

  export const restaurantData =  [
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "484553",
    "name": "Chai Point",
    "uuid": "60e27f02-f8f1-44fa-a9c0-177c53d56245",
    "city": "5",
    "area": "Bandra west",
    "totalRatingsString": "1000+ ratings",
    "cloudinaryImageId": "zno6ur1qmgaarwslcfoh",
    "cuisines": [
    "Bakery",
    "Beverages",
    "Maharashtrian",
    "Snacks",
    "Street Food",
    "South Indian",
    "Punjabi"
    ],
    "tags": [],
    "costForTwo": 15000,
    "costForTwoString": "₹150 FOR TWO",
    "deliveryTime": 44,
    "minDeliveryTime": 44,
    "maxDeliveryTime": 44,
    "slaString": "44 MINS",
    "lastMileTravel": 6,
    "slugs": {
    "restaurant": "chai-point-hill-road-bandra-west",
    "city": "mumbai"
    },
    "cityState": "5",
    "address": "Shop no 28, bandra liberty,CHS plot 98 B,hill road, bandra west,Mumbai-400050",
    "locality": "Hill road",
    "parentId": 1607,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "40% off",
    "shortDescriptionList": [
    {
    "meta": "40% off | Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "40% off up to ₹80 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "40% OFF",
    "shortDescriptionList": [
    {
    "meta": "Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "40% off up to ₹80 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "ribbon": [
    {
    "type": "PROMOTED"
    }
    ],
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 6600,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 6600,
    "message": "",
    "title": "Delivery Charge",
    "amount": "6600",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "cid=6384965~p=1~eid=00000187-72fe-6309-001a-aa7f00b10120",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "6 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "484553",
    "deliveryTime": 44,
    "minDeliveryTime": 44,
    "maxDeliveryTime": 44,
    "lastMileTravel": 6,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": true,
    "avgRating": "4.3",
    "totalRatings": 1000,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "651709",
    "name": "Amritsari & Panjbai Paratha",
    "uuid": "9898c234-f015-4aff-ad52-03a90afa0c83",
    "city": "5",
    "area": "Chembur",
    "totalRatingsString": "Too Few Ratings",
    "cloudinaryImageId": "edf7faef3a2a7cd17fa65385e3d76ed8",
    "cuisines": [
    "North Indian"
    ],
    "tags": [],
    "costForTwo": 15000,
    "costForTwoString": "₹150 FOR TWO",
    "deliveryTime": 34,
    "minDeliveryTime": 34,
    "maxDeliveryTime": 34,
    "slaString": "34 MINS",
    "lastMileTravel": 2.799999952316284,
    "slugs": {
    "restaurant": "amritsari-&-panjbai-paratha-huda-city-huda-city",
    "city": "mumbai"
    },
    "cityState": "5",
    "address": "SHOP NO -85 M H B/6 BHARAT NAGAR.TILAK NAGAR ROAD NO 3 CHEMBUR GREATER MUMBAI WARD -M/W MAHARASHTRA -400089, Tilak Nagar, Greater Mumbai Ward-M/W, Greater Mumbai, Maharashtra, 400089",
    "locality": "TILAK NAGAR ROAD NO 3",
    "parentId": 268794,
    "unserviceable": false,
    "veg": false,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "Flat ₹125 off",
    "shortDescriptionList": [
    {
    "meta": "Flat ₹125 off on orders above ₹249",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "₹125 OFF",
    "shortDescriptionList": [
    {
    "meta": "Use MATCHDEAL125",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "Flat ₹125 off on orders above ₹249 | Use code MATCHDEAL125",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 3000,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 3000,
    "message": "",
    "title": "Delivery Charge",
    "amount": "3000",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "2.7 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "651709",
    "deliveryTime": 34,
    "minDeliveryTime": 34,
    "maxDeliveryTime": 34,
    "lastMileTravel": 2.799999952316284,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "--",
    "totalRatings": 0,
    "new": false
    },
    "subtype": "basic"
    },
    {
    "type": "restaurant",
    "data": {
    "type": "F",
    "id": "24458",
    "name": "Anna Idli",
    "uuid": "86ffae7f-8b4c-4cb7-9fca-9c7190f6ac4c",
    "city": "5",
    "area": "Kurla",
    "totalRatingsString": "10000+ ratings",
    "cloudinaryImageId": "qey4uyhqmnhi4unruxa8",
    "cuisines": [
    "South Indian"
    ],
    "tags": [],
    "costForTwo": 10000,
    "costForTwoString": "₹100 FOR TWO",
    "deliveryTime": 27,
    "minDeliveryTime": 27,
    "maxDeliveryTime": 27,
    "slaString": "27 MINS",
    "lastMileTravel": 3,
    "slugs": {
    "restaurant": "anna-idli-chembur-east-chembur",
    "city": "mumbai"
    },
    "cityState": "5",
    "address": "Anna Idli, Shop no. 4, building no.21, Gurukripa CHS Tilak Nagar, Chembur, Mumbai-400089",
    "locality": "Tilak Nagar",
    "parentId": 3790,
    "unserviceable": false,
    "veg": true,
    "select": false,
    "favorite": false,
    "tradeCampaignHeaders": [],
    "aggregatedDiscountInfo": {
    "header": "10% off",
    "shortDescriptionList": [
    {
    "meta": "10% off | Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "10% off up to ₹40 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "aggregatedDiscountInfoV2": {
    "header": "10% OFF",
    "shortDescriptionList": [
    {
    "meta": "Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "10% off up to ₹40 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    }
    ],
    "subHeader": "",
    "headerType": 0,
    "superFreedel": ""
    },
    "chain": [],
    "feeDetails": {
    "fees": [
    {
    "name": "distance",
    "fee": 3600,
    "message": ""
    },
    {
    "name": "time",
    "fee": 0,
    "message": ""
    },
    {
    "name": "special",
    "fee": 0,
    "message": ""
    }
    ],
    "totalFees": 3600,
    "message": "",
    "title": "Delivery Charge",
    "amount": "3600",
    "icon": ""
    },
    "availability": {
    "opened": true,
    "nextOpenMessage": "",
    "nextCloseMessage": ""
    },
    "longDistanceEnabled": 0,
    "rainMode": "NONE",
    "thirdPartyAddress": false,
    "thirdPartyVendor": "",
    "adTrackingID": "",
    "badges": {
    "imageBased": [],
    "textBased": [],
    "textExtendedBadges": []
    },
    "lastMileTravelString": "3 kms",
    "hasSurge": false,
    "sla": {
    "restaurantId": "24458",
    "deliveryTime": 27,
    "minDeliveryTime": 27,
    "maxDeliveryTime": 27,
    "lastMileTravel": 3,
    "lastMileDistance": 0,
    "serviceability": "SERVICEABLE",
    "rainMode": "NONE",
    "longDistance": "NOT_LONG_DISTANCE",
    "preferentialService": false,
    "iconType": "EMPTY"
    },
    "promoted": false,
    "avgRating": "3.9",
    "totalRatings": 10000,
    "new": false
    },
    "subtype": "basic"
    },]